const publicPaths = {
  HOME: '/'
}

const nonAuthenticatedPaths = {
  LOGIN: '/login',
  REGISTER: '/signup',
  SOCIAL_AUTH: '/auth/social/',
  FORGOT_PASSWORD: '/forgotpassword'
}

const authenticatedPaths = {
  TEST_DETAILS: '/tests/:id',
  TEST_SESSION: '/tests/:id/session',
  TEST_RESULT_DETAILS: '/tests/:id/session/:id',
  EXPERTS: '/experts',
  EXPERTS_NEUROPHYSICS_TESTS: 'experts/neurophysicstests',
  HR: '/hr',
  HIGH_SCHOOL_GRADUATES: '/high-school-graduates',
  HIGH_SCHOOL_GRADUATES_PROPOSED_PROFESSIONS: 'high-school-graduates/proposed-professions',
  HIGH_SCHOOL_GRADUATES_FIELDS_OF_STUDY: 'high-school-graduates/fields-of-study',
  HIGH_SCHOOL_GRADUATES_UNIVERSITY_BASE: 'high-school-graduates/university-base',
  HIGH_SCHOOL_GRADUATES_GRADUATE_LESSONS: 'high-school-graduates/graduate-lessons',
  STUDENTS: '/students',
  STUDENTS_CAREER_PATHS: 'students/career-paths',
  STUDENTS_JOB_MAP: 'students/job-map',
  STUDENTS_EARNINGS: 'students/earnings',
  RESULT_HISTORY: '/results',
  RESULT_DETAILS: '/results/:id',
  MY_DEVELOPMENT: '/my-development',
  USER_PROFILE_SETTINGS: '/user-profile-settings'
}

/**
 * Object containing paths for the router.
 */
const paths = {
  ...publicPaths,
  ...nonAuthenticatedPaths,
  ...authenticatedPaths
}

export default paths
